import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stats-grid" }
const _hoisted_2 = { class: "stat-card" }
const _hoisted_3 = { class: "stat-content" }
const _hoisted_4 = { class: "stat-value" }
const _hoisted_5 = { class: "stat-card" }
const _hoisted_6 = { class: "stat-content" }
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "stat-content" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = { class: "stat-content" }
const _hoisted_13 = { class: "stat-value" }

interface Stats {
  totalRequests: number
  pendingRequests: number
  deliveredEquipment: number
  totalEquipment: number
}

interface Props {
  stats: Stats
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsGrid',
  props: {
    stats: { default: () => ({
    totalRequests: 0,
    pendingRequests: 0,
    deliveredEquipment: 0,
    totalEquipment: 0
  }) }
  },
  setup(__props: any) {

/* eslint-disable no-undef */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stat-icon" }, "📋", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "stat-label" }, "Total Requests", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.stats.totalRequests), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-icon" }, "⏳", -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-label" }, "Pending", -1)),
        _createElementVNode("div", _hoisted_7, _toDisplayString(__props.stats.pendingRequests), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-icon" }, "💻", -1)),
      _createElementVNode("div", _hoisted_9, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-label" }, "Inventory", -1)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(__props.stats.totalEquipment), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-icon" }, "🚀", -1)),
      _createElementVNode("div", _hoisted_12, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "stat-label" }, "Delivered", -1)),
        _createElementVNode("div", _hoisted_13, _toDisplayString(__props.stats.deliveredEquipment), 1)
      ])
    ])
  ]))
}
}

})